import { Component, OnInit, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TrendingBlog } from 'src/app/models/article.model';
import { TrendingFeaturedService } from './trending-featured.service';

@Component({
  selector: 'app-trending-featured',
  templateUrl: './trending-featured.component.html',
  styleUrls: ['./trending-featured.component.scss']
})
export class TrendingFeaturedComponent implements OnInit {
  @Input() tabLabels: { trending: string; featured: string } = {
    trending: 'Trending',
    featured: 'Featured'
  };
  @Input() trendingBlogs: TrendingBlog[] = [];
  @Input() featuredBlogs: TrendingBlog[] = [];
  items: MenuItem[] = [];
  activeItem: MenuItem = {};
  constructor(private trendingFeaturedService: TrendingFeaturedService) {}

  ngOnInit(): void {
    this.items = [
      { label: this.tabLabels.trending, icon: 'pi pi-fw pi-calendar' },
      { label: this.tabLabels.featured, icon: 'pi pi-fw pi-star' }
    ];

    this.activeItem = this.items[0]; // Default to the first tab
  }
  tabChange(event: any) {
    this.activeItem = event.activeItem; // Update the active item
  }
}
